var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Hoxton',{attrs:{"revinate_token":_vm.revinate_token,"background_image":_vm.background_image,"template":_vm.template,"portal":_vm.portal,"connection_data":_vm.connection_data},on:{"emitRegistrationMethodData":_vm.handleEmit}})}
var staticRenderFns = []

export { render, staticRenderFns }